module.exports = __webpack_public_path__ + "static/media/fly0029.6051f284.webp";